// Action Cable consumer for WebSocket connections.
//
// This creates a singleton consumer that all channels use.
// The consumer is configured to connect to the Rails Action Cable endpoint.

import { createConsumer } from "@rails/actioncable"

export default createConsumer()

